import yup from '../../../../helpers/yupInstance';
import type { TFunction } from 'i18next';

export function getAddPermissionFormValidation(t: TFunction) {
  return yup.object({
    permission: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.permissionRequired')),
  });
}
